import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import { RemoveCircleOutline } from '@mui/icons-material';

const InventorySizeRow = ({ color,size, index, handleSizeChange, handleRemoveSize, sizeOptions }) => {
  console.log("here is edit data:",size);
  return (<Box sx={{
    display: 'flex',
    gap: 1,
    mb: 0.5,
    alignItems: 'center',
    '& .MuiTextField-root, & .MuiFormControl-root': {
      backgroundColor: 'white',
    }
  }}>
    <TextField
      label="Color"
      value={size?.color}
      // disabled
      sx={{ width: '14%' }}
    />

    {sizeOptions.map((sizeOption) => (
      <TextField
        key={sizeOption}
        label={sizeOption}
        type="number"
        value={size[sizeOption] || ''}
        onChange={(e) => handleSizeChange(index, sizeOption, e.target.value)}
        sx={{
          width: '14%',
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(0, 0, 0, 0.7)',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.2)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.3)',
          },
          
        }}
      />
    ))}
    <IconButton onClick={() => handleRemoveSize(index)}>
      <RemoveCircleOutline />
    </IconButton>
  </Box>)
};

export default InventorySizeRow;
